import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {AlertOPEEnum} from "./AlertOPEEnum";
import {MetricAlarmStatusEnum} from "../../models/notification/MetricAlarmStatusLite";
import {UserMetricInstance} from "../../models/user/Metric/UserMetricInstance";
import {MetricInstanceAlertEntityAdditionalInfo} from "../../models/diagnostic/PartitionAlarm";


class O {
  partitions: PartitionAlarmDTO[];

  constructor() {
    this.partitions = [];
  }


}

class PartitionAlarmDTO {

  id!: number;
  name!: string;
  path!: string;
  hasAlarms!: boolean;
  metricInstanceAlarms!: MetricInstanceAlertDTO[];

}

class MetricInstanceAlertDTO {

  id!: number;
  metricInstance!: UserMetricInstance;
  name!: string;
  enabled!: boolean;
  beginAlarmNotificationOn!: boolean;
  endAlarmNotificationOn!: boolean;
  alarmStatus?: MetricAlarmStatusEnum;
  additionalInfo?: MetricInstanceAlertEntityAdditionalInfo;
}


class I {

  partitionId!: number;
  metricInstanceAlarmStatusSet: number[];

  constructor() {
    this.metricInstanceAlarmStatusSet = [];
  }

}

export class GetMetricInstanceAlertStatusCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(AlertOPEEnum.GetMetricInstanceAlertStatus);
    this.i = new I();
    this.o = new O();
  }

}
